<template>
	<div class="provider-slider">
		<button class="arrow" aria-label="Previous" :disabled="activeGroup === 0" @click="prev()"><svg><use xlink:href="#arrow-left"></use></svg></button>
		<button class="arrow" aria-label="Next" :disabled="activeGroup === groupCount-1" @click="next()"><svg><use xlink:href="#arrow-right"></use></svg></button>
		<div class="provider-slider-outer">
			<div class="provider-slider-inner"
				 :class="`t${providers.length} a${activeGroup} g${groupCount}`" v-hammer:swipe.left.right="onSwipe">
				<div class="provider-card"
					 :class="{'is-selected': provider.id === selectedProvider.id}"
					 v-for="provider in providers"
					 :key="provider.id"
					 @click="selectProvider(provider, $event)">

					<div class="card-logo"><svg><use :xlink:href="`#provider-${provider.slug.replace(/_/g, '-')}`"></use></svg></div><!-- end.card-logo -->
					<div class="card-footer">Approx {{ provider.meta.average_install_weeks && provider.meta.average_install_weeks > 1 ? `${provider.meta.average_install_weeks} weeks` : `1 week`}} Installation<sup>1</sup></div><!-- end.card-footer -->
				</div><!-- end.provider-card -->

			</div><!-- end.provider-slider-inner -->
		</div><!-- end.provider-slider-outer -->
		<ul class="slider-dots">
			<li v-for="group in groupCount"
				:key="group"
				:class="{'is-active': group === activeGroup+1}"
				@click="activeGroup = group-1"></li>
		</ul><!-- end.slider-dots -->
	</div><!-- end.provider-slider -->
</template>
<script>
	export default {
		props: ['providers', 'selectedProvider'],
		computed: {
			groupCount() {
				let providers = this.providers;

				if(!providers) return 0;

				if(this.isMobile) return providers.length;
				if(this.isTabletPortrait) return Math.ceil(providers.length/2);
				if(this.isTablet) return Math.ceil(providers.length/3);

				return Math.ceil(providers.length/4);
			},
		},
		data() {
			return {
				activeGroup: 0,
				isMobile: window.innerWidth <= 600,
				isTabletPortrait: window.innerWidth <= 780,
				isTablet: window.innerWidth <= 1100,
			}
		},
		methods: {
			prev(){
				if(this.activeGroup > 0) {
					this.activeGroup--;
				}

				// select the provider on mobile
				if (this.isMobile) {
					this.selectProvider(this.providers[this.activeGroup]);
				}
			},
			next(){
				if(this.activeGroup < this.groupCount-1) {
					this.activeGroup++;
				}

				// select the provider on mobile
				if (this.isMobile) {
					this.selectProvider(this.providers[this.activeGroup]);
				}
			},
			selectProvider(provider, e) {
				if (dataLayer && e) {
					console.log("pushing GTM event")
					dataLayer.push({
						event: 'Browse_Packages.Provider.Click',
						provider: provider.slug
					})
				}
				this.$emit('update', provider);
			},
			onSwipe(event) {
				if (this.isMobile) {
					switch (event.type) {
						case 'swipeleft':
							this.next();
							break;
						case 'swiperight':
							this.prev();
							break;
					}
				}

			}
		},
		mounted() {
			this.selectProvider(this.providers[0]);
			window.addEventListener('resize', () => {
				this.isMobile = window.innerWidth <= 600;
				this.isTabletPortrait = window.innerWidth <= 780;
				this.isTablet = window.innerWidth <= 1100;

				if(this.activeGroup > this.groupCount-1) {
					this.activeGroup = this.groupCount-1;
				}

			});
		}
	}
</script>
